import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import VueTelInput from 'vue-tel-input';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import moment from 'moment';
// import Snotify, { SnotifyPosition } from "vue-snotify/vue-snotify.min.js";
// import "vue-snotify/styles/material.css";
import '@/firebase/';

Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype, '$moment', {
  get() {
    return moment;
  },
});

// const options = {
//   toast: {
//     position: SnotifyPosition.rightTop
//   }
// };

// Vue.use(Snotify, options);
Vue.use(VueTelInput);
Vue.use(Vuelidate);

Vue.use(VueReCaptcha, {
  siteKey: '6LdtVsIUAAAAAHcD1v4a2p9Nx3ihb2-Bn-wD9AJV',
  loaderOptions: {
    autoHideBadge: true,
  },
});

axios.defaults.baseURL =
  //dev
  //  'http://local.salondeck.com'
  // 'https://localhost:44387';

//Kami
//'https://kami-api.sytes.net/';

// LIVE PROD
"https://api.salondeck.com/";

// demo
//"https://appointmentapi.sytes.net/";

axios.defaults.headers.common['Content-Type'] = 'application/json';
//axios.defaults.withCredentials = false;

// #############
axios.interceptors.request.use(
  (config) => {
    store.commit('load', true);

    if (config.url == '/graphql') {
      let token = store.getters.token;

      if (!token) {
        store.dispatch('logout');
      }
      //send token
      config.headers.common['Authorization'] = token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// #############
axios.interceptors.response.use(
  (res) => {
    store.commit('load', false);
    return res;
  },
  (error) => {
    store.commit('load', false);
    // TODO Important
    if (error.message == 'Network Error') {
      MyAPP.$snotify.error('Connection lost with the server');
      store.dispatch('logout');
    }
    Promise.reject(error);
  }
);

const MyAPP = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
